import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 更改场景色调
 */

export default class EventUpateSceneHue extends EventBase {
  /**
   * 构造函数
   */
  constructor() {
    super()
    this.Parameter = ['', '0', '0', '']
  }

  // #region 事件内关键属性参数
  /**
   * RGB颜色值
   */
  get RGB() {
    return this.Parameter![0]
  }
  set RGB(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  /**
   * 饱和度
   */
  get Saturation() {
    return parseInt(this.Parameter?.[1] ?? '')
  }
  set Saturation(value) {
    this.Parameter && (this.Parameter[1] = value.toString())
  }

  /**
   * 时间
   */
  get Time() {
    return parseInt(this.Parameter?.[2] ?? '')
  }
  set Time(value) {
    this.Parameter && (this.Parameter[2] = value.toString())
  }

  /**
   * 描述信息
   */
  get Description() {
    return this.Parameter![3]
  }
  set Description(value) {
    this.Parameter && (this.Parameter[3] = value.toString())
  }

  //   // #endregion

  /**
   * 事件ID
   */
  Code = EventID.UpateSceneHue

  /**
   * 获得该事件在事件列表的描述信息
   */
  /// <returns>事件描述信息</returns>
}
